import { type ListDropdownItem } from '@sr/types';
import { type UserPickerItem, type UserPickerMeta } from './types';

export const toDropdownItems = (users: UserPickerItem[]): ListDropdownItem<UserPickerMeta>[] =>
  users.map((user) => ({
    value: user.userId,
    label: user.name,
    type: 'value' as const,
    children: [],
    disabled: user.disabled,
    meta: {
      email: user.email,
      badge: user.badge,
      isUnselectable: user.disabled,
    },
  }));

export const userSearchItems = (
  items: ListDropdownItem<UserPickerMeta>[],
  search: string,
): Promise<ListDropdownItem<UserPickerMeta>[]> => {
  const lowerSearch = search.toLowerCase();

  return Promise.resolve(
    items.filter((item) => {
      const labelMatch = item.label.toLowerCase().includes(lowerSearch);
      const emailMatch = item.meta?.email.toLowerCase().includes(lowerSearch) ?? false;

      return labelMatch || emailMatch;
    }),
  );
};
